import classNames from 'classnames';
import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import styled from 'styled-components';

import { Error } from 'components/Icons/Error';

const ErrorToast = styled.div`
  display: flex;
  align-items: center;
  color: white;
  line-height: 16px;

  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  span {
    word-break: break-word;
  }
`;

export const showError = (message: string, options: ToastOptions = {}) => {
  if (options.autoClose === false) {
    options.className = classNames(options.className || '', 'toast-with-close');
  }
  return toast.error(
    <ErrorToast>
      <Error />
      <span>{message}</span>
    </ErrorToast>,
    options,
  );
};
